let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hq4Ox")).then(() => parcelRequire('LP66E'));